import { Outlet } from 'react-router';

export const MusicReportLayout = () => <Outlet />;
